import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { MenuItem } from '../model/menu-item';

export const menuItems: MenuItem[] = [
    { type: 'link', label: marker('header.menu.dashboard'), icon: 'house', route: ['dashboard'], testId: 'nav-dashboard' },
    { type: 'link', label: marker('header.menu.pathways'), icon: 'stack', route: ['library'], testId: 'nav-library' },
];

export const bottomMenuItems: MenuItem[] = [
    { type: 'link', label: marker('header.menu.support'), icon: 'chat', route: ['support'], disabled: true, testId: 'nav-support' },
    { type: 'link', label: marker('header.menu.settings'), icon: 'gear', route: ['settings'], disabled: true, testId: 'nav-settings' },
    { type: 'link', label: marker('header.menu.logout'), icon: 'logout', route: ['auth', 'logout'], testId: 'nav-logout' },
];
